import { Collection } from '../Tiles/TileSet';
import Core from '../Core/Core';
import { ICollectablesData } from '../State/reducers/player';

export const getSpriteId = (spriteId: string, collection: Collection) => {
    let value = spriteId + '-' + collection;
    if (!PIXI.utils.TextureCache[value]) {
        value = spriteId;
    }
    return value;
};

export const getUnlockedCollections = () => {
    const collectablesProgress = Core.store.getState().StatePlayer.collectablesProgress;
    return Object.keys(collectablesProgress).filter(x => collectablesProgress[x] === 100);
};

export const availableCollections = () => {
    return Object.values(Collection).filter(x => x !== Collection.COMING_SOON);
};

export const getTargetProgress = (tokens: number) => {
    const collection = getCollectionInProgress();
    const currentProgress = getCollectionProgress(collection);
    const adds = currentProgress + clampProgress(tokens);
    const result: [Collection, number] = [collection as Collection, adds];
    return result;
};

export const clampProgress = (tokens: number) => {
    const collection = getCollectionInProgress();
    const currentProgress = getCollectionProgress(collection);
    return Math.min(tokens, 100 - currentProgress);
};

export const getCollectionInProgress = (collectablesProgress?: ICollectablesData) => {
    collectablesProgress =
        collectablesProgress || Core.store.getState().StatePlayer.collectablesProgress;
    const progressKeys = Object.keys(collectablesProgress);
    let collection = progressKeys.find(key => collectablesProgress[key] < 100);
    if (!collection) {
        const lastUnlocked = progressKeys[progressKeys.length - 1];
        const collectionValues = Object.values(Collection);
        //@ts-ignore
        collection = collectionValues[collectionValues.indexOf(lastUnlocked) + 1];
    }
    return collection;
};

export const getCollectionProgress = (
    collection: string,
    collectablesProgress?: ICollectablesData
) => {
    collectablesProgress =
        collectablesProgress || Core.store.getState().StatePlayer.collectablesProgress;
    return collectablesProgress[collection] || 0;
};
